import React, { type SyntheticEvent, memo } from "react";
import { type DropdownProps } from "semantic-ui-react";

import ContextSwitcherDropdown from "../contextSwitcherDropdown/contextSwitcherDropdown";
import { type NavigationDropdownProps } from "./types";
import { useNavigate, useLocation } from "react-router";

function NavigationDropdown(props: NavigationDropdownProps) {
  const location = useLocation();
  const navigate = useNavigate();

  const handleChange = (_: SyntheticEvent<HTMLElement, Event>, data: DropdownProps) => {
    navigate(data.value as string);
  };

  return <ContextSwitcherDropdown defaultOption={location.pathname} onChange={handleChange} {...props} />;
}

export default memo(NavigationDropdown);
